<template>
  <div class="tswrapper">
    <div class="tscontent">
      <div class="tsbox" v-for="(item, index) in newsData" :key="index">
        <h3 @click="$router.push(`/minfoContent/${item.id}`)">
          {{ item.name }}
        </h3>
        <div class="tstime">
          <p>时间 : {{ item.magtime }}</p>
          <p>浏览量 : {{ item.magcount }}</p>
        </div>
      </div>
    </div>
    <div class="tspage" v-if="paginations.total > paginations.page_size">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="paginations.page_index"
        :page-size="paginations.page_size"
        :total="paginations.total"
        layout="prev, pager, next"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import Bus from "@/utils/bus.js";
import { getInfo } from "@/api/news.js";
import { BASE_URL } from "@/utils/base.js";
export default {
  data() {
    return {
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      newsData: [],
    };
  },
  props: {
    fenlei: {
      type: String,
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getData();
  },
  methods: {
    async getData() {
      let news = new FormData();
      news.append("page", this.paginations.page_index);
      news.append("rows", this.paginations.page_size);
      news.append("dentity", this.fenlei);
      let note = await getInfo(news);
      this.paginations.total = note.total;
      this.newsData = note.rows;
      this.newsData.map((item) => {
        item.magtime = item.magtime.substring(0, 10);
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.paginations.page_index = val;
      this.getData();
    },
  },
  components: {},
};
</script>
<style lang="less" scoped>
.tswrapper {
  width: calc(100vw - 60px);
  margin: 0 auto;
  .tscontent {
    width: 100%;
    .tsbox {
      width: calc(100% - 80px);
      background-color: #fff;
      border-radius: 10px;
      padding: 30px 40px;
      margin-bottom: 20px;
      h3 {
        font-size: 28px;
        color: #333;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow:ellipsis;
        &:hover {
          text-decoration: underline;
        }
      }
      .tstime {
        margin: 20px 0;
        display: flex;
        justify-content: space-between;
        p {
          font-size: 14px;
          color: #d0d0d0;
        }
      }
    }
  }
  .tspage {
    margin-top: 40px;
    text-align: center;
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #fd7a3a;
      border: none;
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
      background-color: #fff; // 进行修改未选中背景和字体
      padding: 0 14px;
      font-size: 26px;
      height: 50px;
      line-height: 50px;
      margin: 0 10px;
      // color: #fff;
    }
    /deep/ .el-pagination.is-background button {
      background-color: #fff; // 进行修改未选中背景和字体
      border: 1px solid #ededed;
      font-size: 26px;
      height: 50px;
      line-height: 50px;
       padding: 0 10px;
      // color: #fff;
    }
  } 
}
</style>